import { render, staticRenderFns } from "./PseudoCarousel.vue?vue&type=template&id=714b033d&"
import script from "./PseudoCarousel.vue?vue&type=script&lang=js&"
export * from "./PseudoCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports